// extracted by mini-css-extract-plugin
var _1 = "DocFlowTableRow-moduleDocFlowTableRow__xSBxq TableComponent-modulerow__xPAo4";
export { _1 as "DocFlowTableRow" }
